export const steps = [
    'Register Account',
    'Connect To Bank',
    'Round-Up Accounts',
    'Funding Account',
    'Debt Source',
  ];